import * as React from 'react';
import { connect } from 'react-redux';
import * as LoginActions from '../../actions/LoginActions';
import type { IConnectedComponentProps } from '../../domain';

export class SingleSignOn extends React.PureComponent<IConnectedComponentProps> {
	componentDidMount() {
		const { dispatch } = this.props;

		const externalId = LoginActions.getParameterByName('external_id');
		const siteType = LoginActions.getParameterByName('site_type');
		const ticks = LoginActions.getParameterByName('ticks');
		const token = LoginActions.getParameterByName('token', false);
		const redirectUri = LoginActions.getParameterByName('redirect_uri');

		dispatch(
			LoginActions.singleSignOn(externalId, siteType, ticks, token, redirectUri)
		);
	}

	render() {
		return null;
	}
}

export default connect()(SingleSignOn);
